import { toast } from 'react-toastify';

import ToastAuth from './ToastAuth';
import { AuthToastGlobalStyle } from './styles';

const showAuthToast = ({ title }: { title: string }) =>
    toast(() => <ToastAuth title={title} />, {
        position: 'top-right',
        hideProgressBar: true,
        autoClose: 5000,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

const showUnexpectedAuthErrorToast = () =>
    showAuthToast({
        title: 'Something went wrong, please contact support via chat or hello@lokalise.com',
    });

export default showAuthToast;

export { AuthToastGlobalStyle, showUnexpectedAuthErrorToast };
